import { render, staticRenderFns } from "./button-group.vue?vue&type=template&id=024328d8&scoped=true&lang=pug&"
import script from "./button-group.vue?vue&type=script&lang=coffee&"
export * from "./button-group.vue?vue&type=script&lang=coffee&"
import style0 from "./button-group.vue?vue&type=style&index=0&id=024328d8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024328d8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Btn: require('/opt/build/repo/nuxt-app/components/globals/btn/btn.vue').default})
